import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { CREATE_CHAT } from "src/api-setup/api-endpoints";

export const createChat = async (cookiesData, dispatch, providerId, queryTypeId, inputText) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_user_id: cookiesData?.out_user_id || 0,
      in_tenant_id: cookiesData?.out_tenant_id || "",
      in_conversation_user_key: providerId || "",
      in_conversation_status: "PENDING",
      in_query_type_mstr_key: queryTypeId || 0,
      in_message_text: inputText.trim(),
    };
    const response = await POSTAPI(false, CREATE_CHAT, null, apiHeaders, requestBody, dispatch);
    if (response && response.data) {
      return response;
    }
    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
